import config from "../config.json";
import { apiClient, getAccessToken } from "./apiClient";

const SearchServiceType = async (queryParams) => {
  const token = await getAccessToken();
  queryParams = queryParams || {};
  const params = new URLSearchParams();
  let paramCount = 0;

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value != null && value !== undefined) {
      params.append(key, value);
      paramCount++;
    }
  });

  let url = `${config.API_URL}/service-types/search`;
  if (paramCount > 0) {
    url += `?${params.toString()}`;
  }

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
  };

  try {
    return await apiClient.get(url, {
      headers,
      timeout: config.API_CONNECTION_TIMEOUT,
    });
  } catch (error) {
    throw error;
  }
};

const SearchSubServiceType = async (queryParams) => {
  const token = await getAccessToken();
  queryParams = queryParams || {};
  const params = new URLSearchParams();
  let paramCount = 0;

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value != null && value !== undefined) {
      params.append(key, value);
      paramCount++;
    }
  });

  let url = `${config.API_URL}/sub-service-types/search`; // ✅ endpoint ถูกต้อง
  if (paramCount > 0) {
    url += `?${params.toString()}`;
  }

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
  };

  try {
    return await apiClient.get(url, {
      headers,
      timeout: config.API_CONNECTION_TIMEOUT,
    });
  } catch (error) {
    throw error;
  }
};

const ServiceTypeService = { 
  SearchServiceType,      
  SearchSubServiceType,     
};

export default ServiceTypeService;